module.exports = __webpack_public_path__ + "img/k11.3a73c49f.png";